<div class="action mb-3">
  <div id="divForBorder" [ngClass]="{ action__done: action.action.traiteLe !== null, action__toDo: action.action.traiteLe === null }">
    <div id="divForSeparationInThree" class="d-flex justify-content-between align-items-center">
      <section class="d-flex mt-3 mb-3 me-3 ms-3 align-items-center columnDisplay max-w-25">
        <div class="actionStatusMargins" [ngClass]="{ orangeAction: action.action.traiteLe === null, greenAction: action.action.traiteLe !== null }">
          {{ action?.action?.action }}
        </div>
        @if (action.action.transmisDate) {
          <span class="echeanceDate">{{ 'action.askOn' | translate }} {{ action.action.transmisDate | momentFormat: 'DD/MM/YYYY' }}</span>
        }
        @if (action.action.echeance) {
          <span class="echeanceDate">{{ 'action.forThe' | translate }} {{ action.action.echeance | momentFormat: 'DD/MM/YYYY' }}</span>
        }
      </section>
      <section class="d-flex align-items-start columnDisplay justify-content-center max-w-50 me-3" (click)="action.mailId ? openMail(action) : null">
        <div>
          @if (action.action.transmissionUserName) {
            <span class="boldText">{{ action.action.transmissionUserName }} </span>
          }
          <i class="bi bi-arrow-right"></i>
          @if (action.action.type === 'SERVICE') {
            <span class="boldText">
              {{ action.action.name }} ({{ 'action.service' | translate }})
              @if (action.action.serviceUserName) {
                - {{ action.action.serviceUserName }}
              }
            </span>
          }
          @if (action.action.type === 'GROUPE') {
            <span class="boldText">
              {{ action.action.name }} ({{ 'action.group' | translate }})
              @if (action.action.groupUserName) {
                - {{ action.action.groupUserName }}
              }
            </span>
          }
          @if (action.action.type === 'DESTINATAIRE') {
            <span class="boldText">
              {{ action.action.contactName ? action.action.contactName : action.action.libre }}
              @if (action.action.libre) {
                <span class="boldText"> ({{ 'action.freeRecipient' | translate }})</span>
              }
            </span>
          }
        </div>
        @if (action.mailId) {
          <div>
            <i class="bi bi-box-arrow-up-right fs-13px blue-text cursor--pointer"></i
            ><span class="blue-text cursor--pointer wordBreak"> {{ 'action.mail' | translate }} {{ action.mailId }} - {{ action.objet }}</span>
          </div>
        }
        <div>
          @if (action.action.message) {
            <span
              ><i class="wordBreak">« {{ action.action.message }} »</i></span
            >
          }
          @if (!action.action.message) {
            <span> / ({{ 'action.noMessage' | translate }})</span>
          }
        </div>
        <div>
          @if (action.action.reponse) {
            <span
              >{{ 'tracking.answer' | translate }}: <i class="wordBreak">« {{ action.action.reponse }} »</i></span
            >
          }
        </div>
        <div>
          @if (action.action.commentaires) {
            <span
              >{{ 'action.comment' | translate }}: <i class="wordBreak">« {{ action.action.commentaires }} »</i></span
            >
          }
        </div>
      </section>
      @if (mode === 'asked' || mode === 'assignedToMyTeam') {
        @if (action.action.rights.canReply) {
          <section class="d-flex align-items-center justify-content-end me-3 max-w-25">
            <!-- Action pas traitée -->
            @if (action.action.traiteLe === null) {
              <div class="actionToDoButton actionStatusMargins ms-2" (click)="answerToAction(action)">
                <i class="bi bi-lightning-charge-fill me-2"></i> {{ 'action.process' | translate }}
              </div>
            }
            <!-- Action traitée -->
            @if (action.action.traiteLe !== null) {
              <span>{{ 'action.completedOn' | translate }} {{ action.action.traiteLe | momentFormat: 'DD/MM/YYYY' }}</span>
            }
            @if (action.action.traiteLe !== null) {
              <i class="bi bi-check-circle greenIcon fs-2 ms-2"></i>
            }
          </section>
        }
        <!-- Si l'action est demandée a quelqu'un d'autre -->
        @if (!action.action.rights.canReply) {
          <section class="d-flex align-items-center justify-content-end me-3 max-w-25">
            <!-- Action traitée -->
            @if (action.action.traiteLe !== null) {
              <span>{{ 'action.endOn' | translate }} {{ action.action.traiteLe | momentFormat: 'DD/MM/YYYY' }}</span>
            }
            @if (action.action.traiteLe !== null) {
              <i class="bi bi-check-circle greenIcon fs-2 ms-2"></i>
            }
          </section>
        }
      } @else {
        @if (action.action.traiteLe === null) {
          <section class="d-flex align-items-center justify-content-end me-3 max-w-25">
            @if (action.action.rights.canReply) {
              <div class="actionToDoButton actionStatusMargins ms-2" (click)="answerToAction(action)">
                <i class="bi bi-lightning-charge-fill me-2"></i> {{ 'action.process' | translate }}
              </div>
            }
          </section>
        }
        @if (action.action.traiteLe !== null) {
          <section class="d-flex align-items-center justify-content-end me-3 max-w-25">
            <p class="mb-0" style="white-space: nowrap">
              {{ 'action.completedOn' | translate }} {{ action.action.traiteLe | momentFormat: 'DD/MM/YYYY' }}
            </p>
            <i class="bi bi-check-circle greenIcon fs-2 ms-2"></i>
          </section>
        }
      }
    </div>
  </div>
</div>
